import "./styles/fonts.css";
import "./styles/globals.css";
import "@marketplace/ui/style.css";
import "@marketplace/ui/notifications.css";
import "@marketplace/ui/data-table.css";
import "@/i18n";
import "@/umami";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders, RouterProvider } from "./providers";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider />
    </AppProviders>
  </StrictMode>
);
